import { createAsyncThunk } from '@reduxjs/toolkit';

import { FilterService } from 'api';

import { asyncPayloadCreator } from 'utils';

export const deleteFilter = createAsyncThunk(
	'primaryMarket/deleteFilter',
	(id: string, { rejectWithValue }) =>
		asyncPayloadCreator(id, { rejectWithValue }, FilterService.delete),
);
